import { faMobileAlt } from "@fortawesome/pro-solid-svg-icons";
import { faDesktop } from "@fortawesome/pro-regular-svg-icons";

export const MOBILE = "mobile";
export const DESKTOP = "desktop";

export const DEVICES = {
    1: {
        name: "desktop",
        label: "Desktop",
        icon: faDesktop
    },
    2: {
        name: "mobile",
        label: "Mobile",
        icon: faMobileAlt
    }
};



// WEBPACK FOOTER //
// ./src/modules/devices/constants.js